class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.ourCollections = [
      {
        "title": "Weiterbildung zu Agilem Arbeiten & Soft Skills",
        "handle": "agile-weiterbildungen",
        "variants": ["Agile & Softskills"],
        "bestseller": false,
        "family": "Soft Skills"
      },
      {
        "title": "Weiterbildung zu Content Marketing",
        "handle": "content-marketing-weiterbildungen",
        "variants": ["Content Marketing"],
        "bestseller": true,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu Data Digital Analytics",
        "handle": "data-digital-analytics-weiterbildungen",
        "variants": ["Data Digital Analytics"],
        "bestseller": false,
        "family": "Technology and Analytics"
      },
      {
        "title": "Weiterbildung zu Digital Sales",
        "handle": "sales-weiterbildungen",
        "variants": ["Sales"],
        "bestseller": false,
        "family": "Sales and E-commerce"
      },
      {
        "title": "Weiterbildung zu E-Commerce",
        "handle": "e-commerce-weiterbildungen",
        "variants": ["E-Commerce"],
        "bestseller": false,
        "family": "Sales and E-commerce"
      },
      {
        "title": "Weiterbildung zu E-Mail-Marketing CRM",
        "handle": "e-mail-marketing-weiterbildungen",
        "variants": ["E-Mail-Marketing und CRM"],
        "bestseller": false,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu HR Employer Branding",
        "handle": "hr-employer-branding-weiterbildungen",
        "variants": ["HR Employer Branding"],
        "bestseller": false,
        "family": "HR and Branding"
      },
      {
        "title": "Weiterbildung zu Kuenstliche Intelligenz",
        "handle": "ki-weiterbildungen",
        "variants": ["KI"],
        "bestseller": true,
        "family": "Technology and Analytics"
      },
      {
        "title": "Weiterbildung zu Marketing-Grundlagen",
        "handle": "digital-marketing-weiterbildungen",
        "variants": ["Marketing Grundlagen"],
        "bestseller": false,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu Marketing- und Kreativstrategie",
        "handle": "marketing-strategie-weiterbildungen",
        "variants": ["Marketing-Strategie"],
        "bestseller": false,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu Performance Marketing",
        "handle": "performance-marketing-weiterbildungen",
        "variants": ["Performance Marketing"],
        "bestseller": true,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu SEA Google Ads",
        "handle": "sea-google-ads-weiterbildungen",
        "variants": ["SEA Google Ads"],
        "bestseller": false,
        "family": "Marketing"
          },
      {
        "title": "Weiterbildung zu Suchmaschinenoptimierung (SEO)",
        "handle": "seo-weiterbildungen",
        "variants": ["SEO, Suchmaschinenmarketing"],
        "bestseller": false,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu Social-Media-Marketing",
        "handle": "social-media-marketing-weiterbildungen",
        "variants": ["Social Media Marketing, Instagram Marketing, Meta Ads"],
        "bestseller": false,
        "family": "Marketing"
      },
      {
        "title": "Weiterbildung zu User Experience (UX)",
        "handle": "ux-weiterbildungen",
        "variants": ["UX"],
        "bestseller": false,
        "family": "Design and UX"
      },
    ];
    this.ourProductsTypes = [
      {
        "title": "E-Learning-Kurs",
        "handle": "e-learning-kurs",
        "prio": 1,
        "variants": ["OMR Academy", "OMR Academy Kompakt", "CSD", "E-Learning-Kurs"]
      },
      {
        "title": "Online-Seminar",
        "handle": "online-seminar",
        "prio": 2,
        "variants": ["OMR Deep Dive", "OMR Deep Dive Einzelsession", "Online-Seminar"]
      },
      {
        "title": "Praxis-Guide",
        "handle": "praxis-guide",
        "prio": 3,
        "variants": ["OMR Report", "OMR Report Kompakt","Praxis-Guide"]
      },
    ]
    this.viewedProducts = [];
    this.maxSuggestions = 3;
  }
   async connectedCallback() {
    this.viewedProducts = JSON.parse(localStorage.getItem("viewedProducts")) || [];
    if(!this.viewedProducts || this.viewedProducts.length === 0) return this.renderWhenNoProductsViewed();
    const [userCollection, userProducts] = this.refineViewedProducts();
    const fetchedProducts = await this.fetchRecommendedProducts(userCollection);
    if(fetchedProducts.length === 0) return this.renderWhenNoProductsViewed();
    const refinedFetchedProducts = this.refineFetchedProducts(fetchedProducts, userProducts);
    this.renderSuggestions(refinedFetchedProducts);

  }
  refineViewedProducts() {
    let refinedViewedProducts = new Map();
    this.viewedProducts.forEach(product => {
      const productsCollections = product.collection.split(",").map(collection => collection.trim());
      if(productsCollections.length === 0) return;
      productsCollections.forEach(productCollection => {
        this.ourCollections.forEach(ourCollection => {
          const isInCollection = ourCollection.variants.includes(productCollection)
          if(!isInCollection) return
          if(refinedViewedProducts.has(ourCollection.handle)){
            const existingProducts = refinedViewedProducts.get(ourCollection.handle);
            refinedViewedProducts.set(ourCollection.handle, [...existingProducts, product])
          } else {
            refinedViewedProducts.set(ourCollection.handle, [product])
          }
        });
      });
    });
    // Sort the Map by array size (largest first)
    const sortedEntries = Array.from(refinedViewedProducts.entries()).sort((a, b) => {
      return b[1].length - a[1].length;
    });
    
    return  sortedEntries.length > 0 ? sortedEntries[0] : [];
  }
  /* */
  async fetchRecommendedProducts(handle) {
    if (!handle || typeof handle !== "string") {
      return [];
    }
    const normalizedHandle = handle.trim();
    if (!normalizedHandle) {
      return [];
    }
    const knownHandles = new Set(this.ourCollections.map(collection => collection.handle));
    if (!knownHandles.has(normalizedHandle)) {
      console.warn("[product-recommendations] unknown collection handle:", normalizedHandle);
      return [];
    }

    const url = `/collections/${encodeURIComponent(normalizedHandle)}/products.json`;
    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) {
        console.warn("[product-recommendations] failed collection response:", normalizedHandle, response.status);
        return [];
      }
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        console.warn("[product-recommendations] non-JSON collection response:", normalizedHandle);
        return [];
      }
      const data = await response.json();
      return data?.products || [];
    } catch (error) {
      console.warn("[product-recommendations] error fetching collection:", normalizedHandle, error);
      return [];
    }
  }
  refineFetchedProducts(fetchedProducts, userProducts) {
    //removing all products that user have already seen
    const userProductIds = userProducts.map(product => Number(product.productId));
    const fetchedProductsMap = new Map();
    fetchedProducts.forEach(product => {
      if(userProductIds.includes(Number(product.id))) return;
      const productType = product.product_type;
      this.ourProductsTypes.forEach(ourProductType => {
        if(ourProductType.variants.includes(productType)) {
          if(fetchedProductsMap.has(ourProductType.handle)) {
            const existingProducts = fetchedProductsMap.get(ourProductType.handle);
            fetchedProductsMap.set(ourProductType.handle, [...existingProducts, product]);
          } else {
            fetchedProductsMap.set(ourProductType.handle, [product]);
          }
        };
      });
    });
    
    // Sort map entries by priority (prio 1, 2, 3)
    const sortedEntries = Array.from(fetchedProductsMap.entries()).sort((a, b) => {
      const handleA = a[0];
      const handleB = b[0];
      const prioA = this.ourProductsTypes.find(type => type.handle === handleA)?.prio || 999;
      const prioB = this.ourProductsTypes.find(type => type.handle === handleB)?.prio || 999;
      return prioA - prioB;
    });
    
    // Create a new Map with sorted entries (Maps maintain insertion order)
    return new Map(sortedEntries);
  }
  renderSuggestions(fetchedProductsMap) {
    const suggestedProducts = [];
    for (const [key, entries] of fetchedProductsMap.entries()) {
      const rest = this.maxSuggestions - suggestedProducts.length;
      if(rest <= 0) break;
      const slicedEntries = entries.slice(0, rest);
      suggestedProducts.push(...slicedEntries);
    }
    this.renderHTML(suggestedProducts);
  }
  async renderWhenNoProductsViewed() {
    const bestSellers = this.ourCollections.filter(collection => collection.bestseller).map(collection => collection.handle);
    const handle = bestSellers[Math.floor(Math.random() * bestSellers.length)];
    const fetchedProducts = await this.fetchRecommendedProducts(handle);
    if(fetchedProducts.length === 0) return;
    //we show 10 of products of our best sellers collection
    this.renderHTML(fetchedProducts.slice(0, 10));

  }
  renderHTML(suggestedProducts) {
    if (suggestedProducts.length === 0) {
      this.style.display = 'none';
      return;
    }
    this.innerHTML = '';

    const html = `
      <article class="product-recommendations-intern">
        <div class="product-recommendations-intern-header">
          <p class="product-recommendations-intern-title">Empfohlene Weiterbildungen</p>
          <div class="product-recommendations-intern-controls">
            <button class="product-recommendations-intern-prev" aria-label="Previous" disabled>
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="product-recommendations-intern-next" aria-label="Next" ${suggestedProducts.length <= 1 ? 'disabled' : ''}>
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="product-recommendations-intern-products">
          ${suggestedProducts.map((product, index) => {
            const imageUrl = `${product.images[0].src}&width=200` 
            const price = Number(product.variants[0].price);
            const comparePrice = Number(product.variants[0].compare_at_price);
            return `
              <div class="product-recommendations-intern-product ${index === 0 ? 'is-visible' : ''}" data-index="${index}">
                <img width="100" height="100" src="${imageUrl}" alt="${product.title || ''}" ${index === 0 ? 'loading="eager"' : 'loading="lazy"'} decoding="async" style="cursor: pointer;" onclick="pushEventToDataLayer('cartRecommendationsClick', '', window.location.href, ''); this.closest('.product-recommendations-intern-product').querySelector('a').click();">
                <div class="product-recommendations-intern-product-info">
                  <p class="product-recommendations-intern-product-title">
                    <a href="/products/${product.handle}" onclick="pushEventToDataLayer('cartRecommendationsClick', '', window.location.href, '');">${product.title || ''}</a>
                  </p>
                  <p class="product-recommendations-intern-product-price"> ${comparePrice > price ? `<s style="color:#851639;">${comparePrice} €</s> ${price} €` : `${price} €`} </p>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      </article>
    `;
    
    this.innerHTML = html;
    this.preloadImages();
    this.setupCarousel(suggestedProducts.length);
  }
  
  preloadImages() {
    const images = this.querySelectorAll('.product-recommendations-intern-product img');
    images.forEach(img => {
      if (img.src && !img.complete) {
        const preloadImg = new Image();
        preloadImg.src = img.src;
      }
    });
  }
  
  setupCarousel(totalProducts) {
    if (totalProducts <= 1) return;
    
    const prevButton = this.querySelector('.product-recommendations-intern-prev');
    const nextButton = this.querySelector('.product-recommendations-intern-next');
    const products = this.querySelectorAll('.product-recommendations-intern-product');
    let currentIndex = 0;
    
    const updateCarousel = () => {
      products.forEach((product, index) => {
        if (index === currentIndex) {
          product.classList.add('is-visible');
        } else {
          product.classList.remove('is-visible');
        }
      });
      
      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex === totalProducts - 1;
    };
    
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      pushEventToDataLayer("cartRecommendationsArrowClick", "", window.location.href, "");
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });
    
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      pushEventToDataLayer("cartRecommendationsArrowClick", "", window.location.href, "");
      if (currentIndex < totalProducts - 1) {
        currentIndex++;
        updateCarousel();
      }
    });
    
    updateCarousel();
  }
}
customElements.define("product-recommendations-intern", ProductRecommendations);

